<template>
  <Card class="p-5 mb-5" id="dns-card">
    <!--begin::Body-->
    <div class="card-body d-flex p-0">
      <!--begin::Action-->
      <div class="m-0">
        <!--begin::Title-->
        <div
          class="position-relative fs-2x z-index-2 fw-bolder text-white mb-7"
        >
          <div class="mb-3" v-html="$t('dashboard.dnsInfoLine1')"></div>
          <div class="mb-3" v-html="$t('dashboard.dnsInfoLine2')"></div>
        </div>
        <!--end::Title-->
        <!--begin::Action-->
        <div>
          <a
            href="/networking/domain-name-service"
            class="btn btn-primary rounded-sm"
            >{{ $t('dashboard.goDNSService') }}</a
          >
        </div>
        <!--begin::Action-->
      </div>
      <!--begin::Illustration-->
      <img
        src="/image/illustration1.png"
        class="illustration position-absolute me-3 bottom-0 end-0 h-200px"
        alt=""
      />
      <!--end::Illustration-->
    </div>
    <!--end::Body-->
  </Card>
</template>

<script>
export default {
  name: 'Dashboard.DnsInfo',
  data() {
    return {
      loading: true,
    }
  },
  created() {
    setTimeout(() => {
      this.loading = false
    }, 1000)
  },
}
</script>

<style lang="scss" scoped>
#dns-card {
  background: #1c325e;
  img.illustration {
    right: 0;
  }
}
</style>
